module.exports = __webpack_public_path__ + "img/CZ.79984b1b.png";